const state = {
  empresa: {},
};

export default state;
